import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDollarShield = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		children: [
			/* @__PURE__ */ _jsx("path", { d: "M0,0h24v24h-24v-24Z" }),
			/* @__PURE__ */ _jsx("path", {
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5,
				d: "M20,11.182c0,4.541 -3.413,8.787 -8,9.818c-4.587,-1.031 -8,-5.277 -8,-9.818v-3.939c0,-0.812 0.491,-1.544 1.243,-1.851l5,-2.046c1.126,-0.461 2.388,-0.461 3.514,0l5,2.046c0.752,0.308 1.243,1.039 1.243,1.851v3.939Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5,
				d: "M12,8.5v-1"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5,
				d: "M12,14.5v1"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5,
				d: "M10.264,13.785c0.259,0.424 0.701,0.717 1.236,0.717h0.5h0.596c0.776,0 1.404,-0.629 1.404,-1.404c0,-0.644 -0.439,-1.205 -1.063,-1.363l-1.875,-0.471c-0.623,-0.156 -1.062,-0.717 -1.062,-1.361c0,-0.776 0.629,-1.404 1.404,-1.404h0.596h0.5c0.533,0 0.975,0.292 1.233,0.715"
			})
		]
	})
});
export default SvgDollarShield;
